import { Component } from '@angular/core';
import {Shared} from "./shared/shared";

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(private shared: Shared) {}
}
